import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { batch_list_loading : true, batch_list: '', batch_list_error: false};

export function managaBatchList(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_BATCH_LIST_ORG:
        return {
          batch_list_loading: true,
          batch_list: '',
          batch_list_error: false
        };
      case organisationConstants.RECEIVE_BATCH_LIST_ORG:
        return {
          batch_list_loading: false,
          batch_list: action.get_batch_list,
          batch_list_error: false
        };
      case organisationConstants.ERROR_BATCH_LIST_ORG:
        return { 
            batch_list_loading: false,
            batch_list: '',
            batch_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageBatchList.reducer.js